var exports = {
  "kL": "SlowmodeIndicator.module__container___QnJjQU",
  "K2": "SlowmodeIndicator.module__cooldown___QnJjQU",
  "Pf": "SlowmodeIndicator.module__label___QnJjQU",
  "Kk": "SlowmodeIndicator.module__icon___QnJjQU",
};

module.exports = exports;
